<template>
  <div>
    <base-crud
      crud-name="Solicitações de ausencia"
      new-text="Nova Solicitação"
      :table="absencesRequestsTable"
      :columns="columns"
      :options="options"
      :end-point="endPoint"
      :enable-add="true"
      :enable-edit="false"
      :enable-delete="false"
      :enable-view="false"
      :data-form="dataForm"
    />
  </div>
</template>

<script>
import BaseCrud from '../Base/BaseCrud'

function format(datetime) {
  return moment(datetime).format('DD/MM/YYYY HH:mm:ss')
}

export default {
  components: {
    BaseCrud,
  },
  data() {
    return {
      absencesRequestsTable: 'absencesRequestsTable',
      columns: [
        'id',
        'datetime',
        'user_id',
        'approver_id',
        'status_id',
        'approver_description',
      ],
      tableData: [
        'id',
        'datetime',
        'user_id',
        'approver_id',
        'status_id',
        'approver_description',
      ],
      options: {
        filterByColumn: true,
        filterable: [
          'id',
          'datetime',
          'user_id',
          'approver_id',
          'status_id',
          'approver_description',
        ],
        sortable: [
          'id',
          'datetime',
          'user_id',
          'approver_id',
          'status_id',
          'approver_description',
        ],
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: 'ID',
          datetime: 'Data e hora',
          user_id: 'Usuário',
          approver_id: 'Aprovador',
          status_id: 'Status',
          approver_description: 'Justificativa do Aprovador',
        },
        requestFunction(data) {
          const requestData = {}

          const query = this.$parent.$parent.$parent.query(data.query)
          requestData.params = data
          requestData.params.query = ''
          requestData.params.with = ['user', 'approver', 'status']

          return axios.get(`${this.url}?${query}`, requestData).catch(
            e => {
              this.dispatch('error', e)
            },
          )
        },
        templates: {
          datetime(h, row, index) {
            return format(row.datetime)
          },
          user_id(h, row, index) {
            return row.user.name
          },
          approver_id(h, row, index) {
            return row.approver ? row.approver.name : ''
          },
          status_id(h, row, index) {
            return row.status.name
          },
        },
      },
      endPoint: 'absencerequests/',
      dataForm: {},
    }
  },
  methods: {
    query(query) {
      const columns = {
        id: 'id',
        datetime: 'datetime',
        user_id: 'user_id',
        approver_id: 'approver_id',
      }
      let filters = ''
      $.each(query, (index, value) => {
        filters += `${columns[index]}=${value}&`
      })

      return filters
    },
  },
}
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
